import { Badge, Card, Image, Space, Stack, Text } from "@mantine/core"
import { useTranslation } from "react-i18next"

import { PublicResponses } from "@tfg/types/endpoints/public"

import hanger from "~/assets/images/hanger.svg"
import shoe from "~/assets/images/shoe.svg"

type Props = {
  product: PublicResponses.ProductCard
  primaryColor: string
}

export const ProductCard = ({ product, primaryColor }: Props) => {
  const { t } = useTranslation("public")

  return (
    <Card
      radius="md"
      withBorder
      component="a"
      href={product.agecPopinUrl}
      target="_blank"
    >
      <Card.Section>
        <Image
          src={product.picture}
          alt={product.name}
          fit="contain"
          h={240}
          fallbackSrc={product.type.includes("FOOTWEAR") ? shoe : hanger}
        />
      </Card.Section>
      <Stack gap="lg" mt="xs" justify="space-between">
        <Stack gap={1}>
          <Text fw={600}>{product.name}</Text>
          <Text fw={600}>{product.brand}</Text>
        </Stack>

        <Stack gap={4} align="flex-start" justify="flex-end">
          {product.collection ? (
            <Badge c="primary.0" bg={primaryColor}>
              {product.collection}
            </Badge>
          ) : (
            <Space h={20} />
          )}
          <Stack gap={4} align="flex-start" justify="flex-end">
            <Text fw={400}>{t("productCard.reference")}</Text>
            <Text fw={700}>{product.brandReference}</Text>
          </Stack>
          <Stack gap={4} align="flex-start" justify="flex-end">
            <Text fw={400}>{t("productCard.productType")}</Text>
            <Text fw={700}>{product.brandType}</Text>
          </Stack>
        </Stack>
      </Stack>
    </Card>
  )
}
